import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { environment } from '../../../environments/environment';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { BoardHolderService } from './../../core/board/board.holder.service';
import { UserClerkService } from './../../core/user/user-clerk.service';
import { WorkspaceHolderService } from './../../core/workspace/workspace.holder.service';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzUploadModule,
    NzModalModule,
    NzPopconfirmModule,

    MatTooltip,

    InterviewSidebarComponent,
  ],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PricingComponent {
  constructor(
    private userClerkService: UserClerkService,
    private workspaceHolderService: WorkspaceHolderService,
    private boardHolderService: BoardHolderService
  ) {}

  user = toSignal(this.userClerkService.getUser$());

  getClientReferenceId() {
    const result = `${this.user()!.id}___${this.workspaceHolderService.currentWorkspace().id}___${this.boardHolderService.myPersonalBoard()!.id}`;
    return result;
  }

  getPricingTableId() {
    return environment.stripe.pricingTableId;
  }

  getKey() {
    return environment.stripe.publishableKey;
  }
}
